import sortBy from 'lodash/sortBy';

import type { LessonActivitiesFragment } from '../lesson-builder.graphql.generated';
import { SectionOrSubSectionOverview } from '../activity-builder.constants';
import { StudentSectionOrSubSectionOverview } from 'approot/activity-builder/student/student.constants';
import type { Pluck } from 'lib/gql/pluck';

export const getActivityDetailsFromOverview = ({
  section,
  sectionsOverview,
}: {
  section: SectionOrSubSectionOverview | StudentSectionOrSubSectionOverview;
  sectionsOverview:
    | SectionOrSubSectionOverview[]
    | StudentSectionOrSubSectionOverview[]
    | null;
}): {
  activityNumber: number;
  currentStep: number;
  totalSteps: number;
  progressLabel: string;
  differentiation: number | null;
  parentSectionId: string | null;
  isCheckPoint: boolean;
} => {
  let totalSteps = 1;
  let currentStep = 1;

  const parentSectionId =
    section && 'parentSectionId' in section
      ? section.parentSectionId
      : section.id;
  const parentSection = (
    sectionsOverview as SectionOrSubSectionOverview[]
  ).find(s => s.id === parentSectionId);

  const parentActivities = (
    sectionsOverview as SectionOrSubSectionOverview[]
  )?.filter(s => !('parentSectionId' in s));
  const activityNumber = parentActivities?.findIndex(
    s => s.id === parentSectionId
  );

  if (parentSection && 'subSectionsOverview' in parentSection) {
    const overviews = sortBy(parentSection.subSectionsOverview, 'sort') || [];
    const subSectionIndex = overviews.findIndex(s => s.id === section.id) || 0;
    totalSteps = overviews.length + 1;
    currentStep = subSectionIndex + 2;
    // subsection list does not include parent section, so we add 2 to account for it
    currentStep = subSectionIndex !== -1 ? subSectionIndex + 2 : 1;
  } else {
    const subSections =
      (section as Pluck<LessonActivitiesFragment, 'sectionsOverview'>)
        .subSectionsOverview || [];
    totalSteps = subSections.length + 1;
  }

  return {
    activityNumber: activityNumber !== -1 ? activityNumber + 1 : 1,
    currentStep,
    totalSteps,
    differentiation: parentSection
      ? parentSection.differentiation
      : section.differentiation,
    isCheckPoint: (section as SectionOrSubSectionOverview).checkPoint,
    parentSectionId,
    progressLabel: `Part ${currentStep} of ${totalSteps}`,
  };
};
